import React from "react";
import PublicNav from "../components/PublicNav";
import Hero from "../components/Hero";
import Winners from "../components/Winners";
import About from "../components/About";
import Idea from "../components/Idea";
import Timeline from "../components/Timeline";
import HowToParticipate from "../components/HowToParticipate";
import Sponsors from "../components/Sponsors";
import FAQ from "../components/FAQ";
import Community from "../components/Community";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#05339c]">
      <PublicNav />
      <Hero />
      <About />
      <Idea />
      <Winners />
      <Timeline />
      <HowToParticipate />
      <Sponsors />
      <FAQ />
      <Community />
      <Footer />
    </div>
  );
};

export default Home;
